module.exports = __webpack_public_path__ + "static/media/first-step.5af4e4be.jpeg";